import bgImg from "assets/images/sign-in-bg-img.jpg";
import _ from "lodash";
import { hogesTheme } from "themes/hoges";

const specificNoordhoffThemeProperties = {
  name: "hogesNoordhoff",
  palette: {
    // BLUE
    primary: {
      brand: "#5F84FF",
      _900: "#DFE6FF",
      _800: "#C1D0FF",
      _700: "#9FB5FF",
      _500: "#5F84FF",
      _400: "#2A3E7A",
      _200: "#1A2852",
    },
    // GREEN
    secondary: {
      brand: "#007A60",
      _900: "#CCE4DF",
      _800: "#A2D6D0",
      _700: "#22604F",
      _400: "#194738",
      _200: "#102F22",
    },
  },
  font: {
    family: {
      main: "Roboto Flex, sans-serif",
      secondary: "Px Grotesk, Helvetica, Arial, sans-serif",
    },
  },
  backgroundPages: {
    loginValidate: bgImg,
  },
};

export const hogesNoordhoffTheme = _.merge({}, hogesTheme, specificNoordhoffThemeProperties);
